import navigationAdminMessagesConfig from './Admin/navigationMessagesConfig';
import navigationLearnerMessagesConfig from './Learner/navigationMessagesConfig';

// Utility function to get the appropriate navigation config based on user type
export const getNavigationConfig = (isAdmin: boolean) =>
  isAdmin ? navigationAdminMessagesConfig : navigationLearnerMessagesConfig;
